import React from "react";
import { Container, Segment } from "semantic-ui-react";

/**
 * footer
 */
function Footer() {
  return (
    <Segment inverted>
      <Container textAlign="center">
        © 2017{" "}
        <a href="http://k4h4shi.com" style={{ color: "white" }}>
          kotaro takahashi
        </a>
      </Container>
    </Segment>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js